import { useState, useEffect, useRef } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { config, priceFormat, numberFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import io from 'socket.io-client';
import { format } from "date-fns";

const OpportunityEditBant = () => {
  const { id_opportunity } = useParams();
  const [ opportunityData, setOpportunityData ] = useState(null);
  const [ leadId, setLeadId ] = useState('');
  const [ leadData, setLeadData ] = useState(null);
  const [ leadEnquiry, setLeadEnquiry ] = useState('');
  const [ bantBudget, setBantBudget ] = useState('');
  const [ bantAuthority, setBantAuthority ] = useState('');
  const [ bantNeed, setBantNeed ] = useState('');
  const [ bantTimeline, setBantTimeline ] = useState('');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    const getOpportunityData = async () => {
      try {
        const fetchOpportunity = await jwtFetch(config.ENDPOINT + 'get/opportunity', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "id_opportunity": id_opportunity
          })
        });
        const responseOpportunity = await fetchOpportunity.json();
        if (responseOpportunity.status === 200) {
          const opportunity = responseOpportunity.data[0];
          setOpportunityData(opportunity);
          setLeadId(opportunity.lead_id);
        } else {
          console.log(responseOpportunity.message);
        }
      } catch (error) {
        console.error('Error in getOpportunityData:', error);
        alert('An error occurred: ' + (error.message || error));
      }
    };    
    getOpportunityData();
  }, [id_opportunity]);

  useEffect(() => {
    const getLeadData = async () => {
      try {
        const fetchLead = await jwtFetch(config.ENDPOINT + 'get/lead', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "id_lead": leadId
          })
        });
        const responseLead = await fetchLead.json();
        if (responseLead.status === 200) {
          const lead = responseLead.data[0];
          setLeadData(lead);
          setLeadEnquiry(lead.lead_enquiry || '');
          setBantBudget(lead.bant_budget || '');
          setBantAuthority(lead.bant_authority || '');
          setBantNeed(lead.bant_need || '');
          setBantTimeline(lead.bant_timeline || '');
        } else {
          console.log(responseLead.message);
        }
      } catch (error) {
        console.error('Error in getLeadData:', error);
        alert('An error occurred: ' + (error.message || error));
      }
    };    
    getLeadData();
  }, [leadId]);

  const updateLead = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);

      const requestLeadUpdate = {
        "id_lead": leadId,
        "lead_enquiry": leadEnquiry,
        "bant_budget": bantBudget,
        "bant_authority": bantAuthority,
        "bant_need": bantNeed,
        "bant_timeline": bantTimeline,
        "updated_on": format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        "updated_by": crmUser.user_keyid,
      }

      const fetchLeadUpdate = await jwtFetch(config.ENDPOINT + 'update/lead_bant', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestLeadUpdate)
      });
      const responseLeadUpdate = await fetchLeadUpdate.json();
      if (responseLeadUpdate.status === 200) {
        window.location.href = '/opportunity/detail/' + id_opportunity;
      } else {
        console.log(responseLeadUpdate.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in updateLead:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="opportunity-lead-edit">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="lead"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <a className="text-secondary" href="/opportunity">Opportunity List</a>
                    <span className="mx-3"><i className="bi bi-chevron-right"/></span>
                    <span>Opportunity Edit</span>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-4">
                    <div className="fs-24">BANT Edit</div>
                  </div>
                  <div className="row mb-4">
                    <div className="col-md-8">
                      <form className="bg-white border-radius-4 p-4" onSubmit={(e) => updateLead(e)} id="submit-form">
                        <div className="border border-1 border-radius-3 p-4 mb-3">

                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Enquiry</label>
                            </div>
                            <div className="col-md-8">
                              <textarea className="form-control" value={leadEnquiry} onChange={(e) => setLeadEnquiry(e.target.value)}/>
                            </div>
                          </div>                              
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Budget</label>
                            </div>
                            <div className="col-md-8">
                              <div className="input-group">
                                <input className="form-control text-end" type="text" value={priceFormat(bantBudget)} onChange={(e) => setBantBudget(numberFormat(e.target.value))}/>
                                <span className="input-group-text mw-85">IDR</span>
                              </div>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Authority</label>
                            </div>
                            <div className="col-md-8">
                              <textarea className="form-control" value={bantAuthority} onChange={(e) => setBantAuthority(e.target.value)}/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-2">
                            <div className="col-md-4">
                              <label>Need</label>
                            </div>
                            <div className="col-md-8">
                              <textarea className="form-control" value={bantNeed} onChange={(e) => setBantNeed(e.target.value)}/>
                            </div>
                          </div>
                          <div className="row form-group align-items-center mb-4">
                            <div className="col-md-4">
                              <label>Timeline</label>
                            </div>
                            <div className="col-md-8">
                              <textarea className="form-control" value={bantTimeline} onChange={(e) => setBantTimeline(e.target.value)}/>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <button className="btn btn-link" type="button" onClick={() => window.location.href = `/opportunity/detail/${id_opportunity}`}>Cancel</button>
                          <button className="btn bg-gold ms-2" type="submit">{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                        </div>
                      </form>
                    </div>                    
                  </div>
                </section>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpportunityEditBant;


